exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.campaign-details[data-v-05bed09c] {\n\tpadding-top:0px;\n}\n.type-label[data-v-05bed09c] {\n\tfont-weight:600;\n\ttext-transform:uppercase;\n}\n", ""]);

// exports
